import litenBatUtenMotor from "./knbf-boat-forms/liten-bat-uten-motor";
import litenBatMedMotor from "./knbf-boat-forms/liten-bat-med-motor";
import vannscooter from "./knbf-boat-forms/vannscooter";
import motorbatBeregnetForOvernatting from "./knbf-boat-forms/motorbat-beregnet-for-overnatting";
import seilbatBeregnetForOvernatting from "./knbf-boat-forms/seilbat-beregnet-for-overnatting";
import seilbatIkkeBeregnetForOvernatting from "./knbf-boat-forms/seilbat-ikke-beregnet-for-overnatting";
import motorbatIkkeBeregnetForOvernatting from "./knbf-boat-forms/motorbat-ikke-beregnet-for-overnatting";
import {Link} from "react-router-dom";

export default function KNBFBoatForms() {
	const forms = {
		"liten-bat-uten-motor": litenBatUtenMotor,
		"liten-bat-med-motor": litenBatMedMotor,
		"vannscooter": vannscooter,
		"motorbat-beregnet-for-overnatting": motorbatBeregnetForOvernatting,
		"seilbat-beregnet-for-overnatting": seilbatBeregnetForOvernatting,
		"seilbat-ikke-beregnet-for-overnatting": seilbatIkkeBeregnetForOvernatting,
		"motorbat-ikke-beregnet-for-overnatting": motorbatIkkeBeregnetForOvernatting,
	}

	return <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%"}}>
		<h1>KNBF - Båt skjemaer</h1>
		<div style={{display: "flex", flexWrap: "wrap", justifyContent: "left", width: "900px"}}>
		{Object.keys(forms).map((key, i) => {
			return <Link className={'button1'} to={key} key={i}>{forms[key].title}</Link>
		})}
	</div></div>
}